/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-25 17:05:11
 */
//员工管理  的员工信息
import http from "../httpConfig"

const table = "mrbase_sys_staffs"
const table1 = "mrbase_sys_staff_personal_info"

// 员工复职
export const resumePost = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-reinstate/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工登录账号冻结接口
export const freezeStaff = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-freezAccount/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 员工登录密码修改接口
export const modifyPassWord = (params = {}) => {
  params["~table~"] = "mrbase_sys_users"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-resetPassWord/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 员工登录密码重置接口
export const resetPassWord = (params = {}) => {
  params["~table~"] = "mrbase_sys_users"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-resetPassWord/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工删除
export const deleteStaff = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-deleteStaff/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工信息得员工属性
export const getpropertydetail = (params = {}) => {
  params["~table~"] = "mrbase_sys_staff_property"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/list-staffProperty/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工信息修改员工属性
export const getpropertyupdate = (params = {}) => {
  params["~table~"] = "mrbase_sys_staffs"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/update-staffProperty/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工信息查询单个详情接口
export const getpropertyonedetail = (params = {}) => {
  params["~table~"] = "mrbase_sys_staff_property"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staffProperty//v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工信息列表接口
export const getStaffMsgList = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/list-staff/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工详情接口
export const getStaffMsgDetail = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staff/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工更新接口
export const getStaffMsgUpdate = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/update-staff/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工个人信息详情
export const getStaffPersonal = (params = {}) => {
  params["~table~"] = table1
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staffPersonal/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工个人信息新增或修改
export const getStaffPersonalUpdate = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-personalAndAddress/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工就业信息详情
export const getStaffJobDetail = (params = {}) => {
  params["~table~"] = "mrbase_sys_staff_employment_info"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staffEmployment/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工就业信息新增或修改
export const getStaffJobUpdate = (params = {}) => {
  params["~table~"] = "mrbase_sys_staff_employment_info"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-employmentInfo/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

const table2 = "mrbase_sys_staff_bank_account"
// 员工银行信息列表
export const getStaffBank = (params = {}) => {
  params["~table~"] = table2
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/list-staffBank/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 员工银行信息详情
export const getStaffBankDetail = (params = {}) => {
  params["~table~"] = table2
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staffBank/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工银行信息新增或修改接口
export const getStaffBankUpdate = (params = {}) => {
  params["~table~"] = "mrbase_sys_staffs"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-bankInfo/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工紧急联系人信息列表
export const getStaffTelList = (params = {}) => {
  params["~table~"] = "mrbase_sys_staff_emergency_contact_info"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/list-staffEmergencyContact/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工紧急联系人信息新增或修改接口
export const getStaffTelUpdate = (params = {}) => {
  params["~table~"] = "mrbase_sys_staffs"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/staff-Liaison/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工地址信息详情
export const getStaffAddressUpdate = (params = {}) => {
  params["~table~"] = "mrbase_sys_staff_address"
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staffAddress/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工管理的  员工离职

//员工离职管理列表接口
const table3 = "mrbase_sys_staff_termination"
export const getStaffLeaveList = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/dimission/list-dimission/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职管理新增
export const addStaffLeave = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/dimission/add-dimission/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职管理修改
export const updateStaffLeave = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/dimission/update-dimission/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职管理删除
export const deleteStaffLeave = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/dimission/delete-dimission/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职申请详情
export const detailStaffLeave = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/dimission/find-dimission/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工管理的  员工离职交接

//员工离职交接列表接口
export const getHandoverList = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/handover/list-handover/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职交接新增接口
export const addHandover = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/dimission/add-dimission/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职交接修改接口
export const updateHandover = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/handover/update-handover/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职交接删除接口
export const deleteHandover = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/handover/delete-handover/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工离职交接删除接口
export const detailHandover = (params = {}) => {
  params["~table~"] = table3
  return new Promise((resolve, reject) => {
    http
      .post("/api/handover/find-handover/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工管理的 员工变更列表
const table4 = "mrbase_sys_staff_movement"
//员工变更列表
export const getStaffVariationList = (params = {}) => {
  params["~table~"] = table4
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffChange/list-change/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工变更详情
export const detailStaffVariation = (params = {}) => {
  params["~table~"] = table4
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffChange/find-change/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工变更新增
export const addStaffVariation = (params = {}) => {
  params["~table~"] = table4
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffChange/add-change/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工变更修改
export const updateStaffVariation = (params = {}) => {
  params["~table~"] = table4
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffChange/update-change/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工变更删除
export const deleteStaffVariation = (params = {}) => {
  params["~table~"] = table4
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffChange/delete-change/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工管理的 员工转正
const table5 = "mrbase_sys_staff_complete_probation"
//员工转正列表
export const getStaffOfficialList = (params = {}) => {
  params["~table~"] = table5
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffRegularEmployee/list-regularEmployee/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工转正详情
export const detailStaffOfficial = (params = {}) => {
  params["~table~"] = table5
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffRegularEmployee/find-regularEmployee/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工转正新增
export const addStaffOfficial = (params = {}) => {
  params["~table~"] = table5
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffRegularEmployee/add-regularEmployee/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工转正修改
export const updateStaffOfficial = (params = {}) => {
  params["~table~"] = table5
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffRegularEmployee/update-regularEmployee/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工转正删除
export const deleteStaffOfficial = (params = {}) => {
  params["~table~"] = table5
  return new Promise((resolve, reject) => {
    http
      .post("/api/staffRegularEmployee/delete-regularEmployee/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//员工管理的 员工群组管理
const table6 = "mrbase_sys_group"
//员工群组管理   公司组列表
export const getStaffCompanyGroupList = (params = {}) => {
  params["~table~"] = table6
  return new Promise((resolve, reject) => {
    http
      .post("/api/select/list-company-group/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const addCompanyGroup = (params = {}) => {
  params["~table~"] = table6
  return new Promise((resolve, reject) => {
    http
      .post("/api/select/save-company-the-group/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const detailCompanyGroup = (params = {}) => {
  params["~table~"] = table6
  return new Promise((resolve, reject) => {
    http
      .post("/api/select/get-company-group-info/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const deleteCompanyGroup = (params = {}) => {
  params["~table~"] = table6
  return new Promise((resolve, reject) => {
    http
      .post("/api/select/delete-the-group/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const getallList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staff-bossAndRole/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
//更具员工uuid查询 公司 部门邓信息
export const fintStaffInfo = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/find-staff-data/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
